<style scoped>
.employee-sidebar{
    overflow: auto;
    height: 100vh;
}
</style>
<template>
    <div class="" >
        <div class="row col-12 px-0 no-margin" v-if="company_assigned">
            <div class="">
                <button class="mobile-toggle-btn" @click="sidebarOpen = !sidebarOpen">
                    <span v-if="!sidebarOpen">&#9776;</span>
                    <span v-else>&times;</span>
                </button>
            </div>
           
            <div v-if="is_line_manager == false" class="w-100">
                <div :class="['mobile-sidebar-wrapper', { open: sidebarOpen }]">
                    <div class="employee-sidebar px-0 col "  >
                        <div class="employee-sidebar-inner">
                            <div class="employee-portal-menu">
                                <div class="list-group">

                                    
                                    <div class=""> 
                                        <button type="button" class="list-group-item list-group-item-action" @click="swapComponent('employee-dashboard')" :class="{ 'menu-active': isActive('employee-dashboard') }">
                                            <span class="active">
                                                <img v-bind:src="media_url+'dashboard.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                Dashboard</span>
                                        </button>
                                    </div>

                                    <div > 
                                        <button type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu">
                                            <span class="active">
                                                <i class="fas fa-user mr-2"></i>
                                                Profile</span>
                                        </button>
                                        <div class="submenu-wrapper">
                                            <button type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('account-employees-front')" :class="{ 'menu-active': isActive('account-employees-front') }">
                                                <span class="active">My Profile</span>
                                            </button>
                                            <button type="button" v-if="company_access_settings['contract'] == true" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-contract-form')" :class="{ 'menu-active': isActive('employee-contract-form') }">
                                                <span class="active">My Contracts</span>
                                            </button>
                                            <button type="button" v-if="service_book_eligible" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('service-book-emp-service-book-dashboard')" :class="{ 'menu-active': isActive('service-book-emp-service-book-dashboard') }">
                                                <span class="active">Service Book</span>
                                            </button>
                                        </div>
                                    </div>

                                    <div > 
                                        <button v-if="company_access_settings['company_directory'] == true"  type="button" class="list-group-item list-group-item-action" @click="swapComponent('company-directory-front')" :class="{ 'menu-active': isActive('company-directory-front') }">
                                            <span class="active"><img v-bind:src="media_url+'Company-Users-blue.png'"  class="vsm--icon leftmenu mr-2 active" width="16px"/><img v-bind:src="media_url+'Company-Users-black.png'"  class="vsm--icon leftmenu mr-2 not-active" width="16px"/>Company Directory</span>
                                        </button>
                                    </div>

                                    <!--<template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div > 
                                            <button type="button" class="list-group-item list-group-item-action" @click="swapComponent('employee-contract-form')" :class="{ 'menu-active': isActive('employee-contract-form') }">
                                                <span class="active"><img v-bind:src="media_url+'Contracts.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>Contracts</span>
                                            </button>
                                        </div>
                                    </template>-->

                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div > 
                                            <button type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu" v-if="company_access_settings['payslips'] == true || company_access_settings['tax_cards'] == true">
                                                <span class="active">
                                                    <img v-bind:src="media_url+'dollar-circle.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                    Payroll</span>
                                            </button>
                                            <div class="submenu-wrapper">
                                                <button v-if="company_access_settings['payslips'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employeepayslips-front')" :class="{ 'menu-active': isActive('employeepayslips-front') }">
                                            
                                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">Pay Slips</span>
                                                    </template>
                                                    <template v-else > <span class="active">PF Slips</span></template> 
                                                </button>
                                                <button v-if="company_access_settings['tax_cards'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-tax-cards')" :class="{ 'menu-active': isActive('employee-tax-cards') }">
                                                
                                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">
                                                            <!-- <img v-bind:src="media_url+'Tax.png'"  class="vsm--icon leftmenu mr-2" width="16px"/> -->
                                                            Tax Cards</span>
                                                    </template>
                                                    <template v-else ><span class="active">Tax Cards</span> <i class="fa fa-lock trz_lock_front_sidebar" aria-hidden="true"></i></template> 
                                                </button>
                                            </div>
                                        </div>
                                    </template>

                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div > 
                                            <button type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu" v-if="company_access_settings['investments'] == true || company_access_settings['advance_income_tax'] == true">
                                                <span class="active">
                                                    <img v-bind:src="media_url+'Taxes.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                    Tax Reducers</span>
                                            </button>
                                            <div class="submenu-wrapper">
                                                <button v-if="company_access_settings['investments'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-investment-info-front')" :class="{ 'menu-active': isActive('employee-investment-info-front') }">
                                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">Investments</span>
                                                    </template>
                                                    <template v-else > <span class="active">Investments</span><i class="fa fa-lock trz_lock_front_sidebar" aria-hidden="true"></i></template> 
                                                </button>
                                                <button v-if="company_access_settings['advance_income_tax'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-ait-info-front')" :class="{ 'menu-active': isActive('employee-ait-info-front') }">
                                                
                                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                                        <span class="active">Advance Income Tax</span>
                                                    </template>
                                                    <template v-else > <span class="active">Advance Income Tax</span><i class="fa fa-lock trz_lock_front_sidebar" aria-hidden="true"></i></template> 
                                                </button>
                                            </div>
                                        </div>
                                    </template>

                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div v-if="addons.includes('LeaveAttendances') && company_access_settings['leave_attendances'] == true"> 
                                            <button type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu">
                                                <span class="active">
                                                    <img v-bind:src="media_url+'leave-attendance.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                    Leave and Attendance</span>
                                            </button>
                                            <div class="submenu-wrapper"> 
                                                <button v-if="company_access_settings['leave_attendances'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-leave-attendance-wrapper-front')" :class="{ 'menu-active': isActive('employee-leave-attendance-wrapper-front') }">
                                                    <span class="active">Personal</span>
                                                </button> 
                                        
                                                <button v-if="is_manager == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('leaveattendances-dashboard-front')" :class="{ 'menu-active': isActive('leaveattendances-dashboard-front') }">
                                                    <span class="active">My Team</span>
                                                </button>

                                                <button v-if="is_approver" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('approver-index')" :class="{ 'menu-active': isActive('approver-index') }">
                                                    <span class="active">My Approval</span>
                                                </button>
                                            </div>
                                        </div>
                                    </template>



                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div v-if="addons.includes('Roster') && company_access_settings['leave_attendances'] == true"> 
                                            <button type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu">
                                                <span class="active">
                                                    <img v-bind:src="media_url+'leave-attendance.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                    Leave and Attendance</span>
                                            </button>
                                            <div class="submenu-wrapper"> 
                                                <button type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('roster-employee-front')" :class="{ 'menu-active': isActive('roster-employee-front') }">
                                                    <span class="active">Personal</span>
                                                </button>
                                                <button v-if="is_roster_approver" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('roster-approver-index')" :class="{ 'menu-active': isActive('roster-approver-index') }">
                                                    <span class="active">My Approval</span>
                                                </button>
                                            </div>
                                        </div>
                                    </template>
                                
                                    <template  v-if="$atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">
                                        <div  v-if="loan_settings == 1"> 
                                            <button type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu" v-if="company_access_settings['loan_and_advance'] == true">
                                                <span class="active">
                                                    <img v-bind:src="media_url+'Loan-advance.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                    Loan and Advance</span>
                                            </button>
                                            <div class="submenu-wrapper">
                                                <button v-if="company_access_settings['loan_and_advance'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-loan-list-front')" :class="{ 'menu-active': isActive('employee-loan-list-front') }">
                                                    <span class="active">Personal</span>
                                                </button>
                                                
                                            </div>
                                        </div>
                                    </template>

                                    <div  v-if="addons.includes('Pf')"> 
                                        <button v-if="company_access_settings['provident_fund'] == true" type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu">
                                            <span class="active">
                                                <img v-bind:src="media_url+'provident-fund.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                Provident Fund</span>
                                        </button>
                                        <div class="submenu-wrapper">
                                            <button v-if="company_access_settings['provident_fund'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-pf-contributions')" :class="{ 'menu-active': isActive('employee-pf-contributions') }">
                                                <span class="active">PF Schedule</span>
                                            </button>
                                            <!-- Start: Rejwan: pf_unified -->
                                            <button v-if="company_access_settings['provident_fund'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-pf-statement-front')" :class="{ 'menu-active': isActive('employee-pf-statement-front') }">
                                                <span class="active">PF Statement</span>
                                            </button>
                                            <!-- End: Rejwan: pf_unified -->
                                            <button v-if="company_access_settings['provident_fund_loan'] == true" type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('pf-employee-loan-list-front')" :class="{ 'menu-active': isActive('pf-employee-loan-list-front') }">
                                                <span class="active">PF Advance</span>
                                            </button> 
                                        
                                            <!-- <template  v-if="$atl_company_package_title == 'Provident Fund Only'">
                                                <button v-if="company_access_settings['provident_fund_loan'] == true" type="button" class="list-group-item list-group-item-action list-item-sub pr-0" @click="swapComponent('pf-employee-loan-application-approve-list-front')" :class="{ 'menu-active': isActive('pf-employee-loan-application-approve-list-front') }">
                                                    <span class="active">Loan Applications</span> <span v-if="approval_pending_data.pf > 0" class="notification">{{approval_pending_data.pf}}</span>
                                                </button>
                                            </template>
                                            <template  v-if="$atl_company_package_title == 'Provident Fund Only'">
                                                <button v-if="company_access_settings['provident_fund'] == true" type="button" class="list-group-item list-group-item-action list-item-sub pr-0" @click="swapComponent('pf-employee-settlement-approve-list-front')" :class="{ 'menu-active': isActive('pf-employee-loan-application-approve-list-front') }">
                                                    <span class="active">Settlements</span> <span v-if="approval_pending_data.pf_settlement > 0" class="notification">{{approval_pending_data.pf_settlement}}</span>
                                                </button> 
                                            </template> -->
                                            <!-- Rejwan: pf_unified -->
                                            <template  v-if="is_advance_settlement_manager.pf == 1">
                                                <button v-if="company_access_settings['provident_fund_loan'] == true" type="button" class="list-group-item list-group-item-action list-item-sub pr-0" @click="swapComponent('pf-employee-loan-application-approve-list-front')" :class="{ 'menu-active': isActive('pf-employee-loan-application-approve-list-front') }">
                                                    <span class="active">PF Advance Applications</span> <span v-if="approval_pending_data.pf > 0" class="notification">{{approval_pending_data.pf}}</span>
                                                </button>
                                            </template>
                                            <template  v-if="is_advance_settlement_manager.pf_settlement == 1">
                                                <button v-if="company_access_settings['provident_fund'] == true" type="button" class="list-group-item list-group-item-action list-item-sub pr-0" @click="swapComponent('pf-employee-settlement-approve-list-front')" :class="{ 'menu-active': isActive('pf-employee-settlement-approve-list-front') }">
                                                    <span class="active">PF Settlements</span> <span v-if="approval_pending_data.pf_settlement > 0" class="notification">{{approval_pending_data.pf_settlement}}</span>
                                                </button> 
                                            </template>
                                            <!-- Rejwan: pf_unified -->
                                        </div>
                                    </div>

                                    <!-- Start: Rejwan: gf_unified -->
                                    <div  v-if="addons.includes('Gf') && company_access_settings['gratuity_fund'] == true"> 
                                        <button  type="button" class="list-group-item list-group-item-action list-item-main" @click="toggleSubmenu">
                                            <span class="active"><img v-bind:src="media_url+'provident-fund.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>Gratuity Fund</span>
                                        </button>
                                        
                                        <div class="submenu-wrapper">
                                            <!-- <button  type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-gf-contributions-front')" :class="{ 'menu-active': isActive('employee-pf-contributions') }"> -->
                                            <template> <!-- Rejwan: 24-08-2026 -->
                                                <button  type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-gf-summery-front')" :class="{ 'menu-active': isActive('employee-gf-summery-front') }">
                                                    <span class="active">GF Summery</span>
                                                </button>
                                            </template> <!-- Rejwan: 24-08-2026 -->
                                            
                                            <template v-if="is_advance_settlement_manager.gf_settlement == 1"> <!-- Rejwan: 24-08-2026 -->
                                                <button type="button" class="list-group-item list-group-item-action list-item-sub" @click="swapComponent('employee-gf-settlement-list-front')" :class="{ 'menu-active': isActive('employee-gf-settlement-list-front') }">
                                                    <span class="active">Settlements</span>
                                                </button>
                                            </template> <!-- Rejwan: 24-08-2026 -->
                                            
                                        </div>
                                    </div>
                                    <!-- End: Rejwan: gf_unified -->
                                    <template  v-if="company_access_settings['documents_portal_access'] == true && $atl_company_package_title != 'Provident Fund Only' && $atl_company_package_title != 'Gratuity Fund Only' && $atl_company_package_title != 'Provident And Gratuity Fund Only'">

                                        <div > 
                                            <button type="button" class="list-group-item list-group-item-action" @click="swapComponent('employee-documents-front')" :class="{ 'menu-active': isActive('employee-documents-front') }">
                                                <span class="active">
                                                    <img v-bind:src="media_url+'Documents.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                                    Documents</span>
                                            </button>
                                        </div>
                                    </template>
                                    
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <!-- end of sidebar  -->
                <div class="employee-content main col-12">
                    <!-- <h6 class="text-center">Container</h6> -->
                    
                    <div :is="currentComponent" :key="componentKey" :flg="1" :addons="this.addons" :employee_id="this.employee_id" v-on:childToParent="setComponent"></div>
                </div>
            </div>
            <div class="w-100" v-else>
                <div class="employee-sidebar px-0 col "  >
                <div class="employee-sidebar-inner">
                    <div class="employee-portal-menu">
                    <div class="list-group" v-if="addons.includes('Roster') && company_access_settings['leave_attendances'] == true">

                        <div class="">
                        <button v-if="is_approver" @click="swapComponent('roster-approver-index')" type="button" class="list-group-item list-group-item-action" :class="{ 'menu-active': isActive('roster-approver-index') }">
                                        <span class="active">
                                            <img v-bind:src="media_url+'dashboard.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                            My Approval</span>
                        </button>
                        </div>


                    </div>
                    <div class="list-group" v-if="addons.includes('LeaveAttendances') && company_access_settings['leave_attendances'] == true">


                        <div class="">
                        <button @click="swapComponent('leaveattendances-dashboard-front')" type="button" class="list-group-item list-group-item-action" :class="{ 'menu-active': isActive('leaveattendances-dashboard-front') }">
                                        <span class="active">
                                            <img v-bind:src="media_url+'dashboard.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                            My Team</span>
                        </button>
                        </div>

                        <div class="">
                        <button v-if="is_approver" @click="swapComponent('approver-index')" type="button" class="list-group-item list-group-item-action" :class="{ 'menu-active': isActive('approver-index') }">
                                        <span class="active">
                                            <img v-bind:src="media_url+'dashboard.png'"  class="vsm--icon leftmenu mr-2" width="16px"/>
                                            My Approval</span>
                        </button>
                        </div>


                    </div>
                    </div>
                </div>

                </div>

                <div class="employee-content main col-12">
                <div :is="currentComponent" :key="componentKey" :flg="1" :addons="this.addons" :employee_id="this.employee_id" v-on:childToParent="setComponent"></div>
                </div>

            </div>
        </div>
        <div class="p-5" v-else>
            <p class="text-center h3 m-4 p-4 col-12 text-white bg-info" v-if="this.no_company_message.length > 0">
                {{this.no_company_message}}
            </p>
        </div>
    </div>
            
        
   
</template>
<script> 
    export default{

        props: [],
        components: {
        
        },
        data(){
            return {
                activeItem: 'employee-dashboard',
                currentComponent: 'employee-dashboard',
                
                media_url : this.$api_url + '/images/menu/',
                public_info : [],
                avatarsrc : '',  
                componentKey:0,
                        
                
                
                company_assigned : false,
                no_company_message : '',
                dCompanyId : 0,
                employees:[],

                length: 20,
                addons : [],
                employee_id:'',
                loan_settings:'',
                company_access_settings:{},
                approval_pending_data:[],

                is_manager : false,
                is_approver : false,
                //submenu_active : true,
                is_line_manager : false,
                sidebarOpen: false,
                is_roster_approver: false,
                is_advance_settlement_manager: [],
                service_book_eligible: false,
            }
        },
        methods:{
            checkServiceBookEligibility: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url + '/front/service-book/check-employee-type')
                    .then(function(response){
                        if (response && response.data === true) {
                            currentObj.service_book_eligible = true;
                        } else {
                            currentObj.service_book_eligible = false;
                        }
                    })
                    .catch(function(error){
                        currentObj.service_book_eligible = false;
                    });
            },
            
		    get_access_settings: function()
            {
                // 
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/company/employee-access-settings' , {
                }).then(function(response){

                    let company_access_settings_temp = {};
                    company_access_settings_temp = response.data;
                    
                    for (const [key, value] of Object.entries(company_access_settings_temp)) {
                        
                            if(value==1)
                            {
                                company_access_settings_temp[key] = true;
                            }
                            else
                            {
                                company_access_settings_temp[key] = false;
                            }

                            }

                    this.company_access_settings = company_access_settings_temp;

                }.bind(this));
            },
            
            swapComponent: function(component_name)
            {
                //
                let currentObj = this;
                if(this.currentComponent == 'leaveattendances-dashboard-front')
                {
                    let formData = new FormData();
                    formData.append('sess', 'subordinate_id');
                    axios.post(this.$api_url+'/front/flushsess', formData)
                                .then(function (response) 
                                {                                    
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                                    
                                    currentObj.serverError(error);
                                });

                        setTimeout( () => {
                            
                            this.currentComponent = component_name;
                            this.$cookies.set("last_clicked_component",component_name);
                            this.activeItem = component_name;
                            }, 
                        500);
                
                    
                
                }
                else
                {

                    
                    this.currentComponent = component_name;
                    this.$cookies.set("last_clicked_component",component_name);
                    this.activeItem = component_name;

                }
                this.sidebarOpen = false;     //mahmud added for refresh sidebar
            },
            setComponent : function(x)
            {
                if(x.component_name)
                    this.swapComponent(x.component_name);
            },
            isActive: function (menuItem) {
                
                return this.activeItem === menuItem;
                // // return this.activeItem === this.currentComponent;
                // return this.currentComponent;
                
            },
            getEmployeePublicData: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/employee/front/publicinfo' , {
                    params: {
                        
                    }
                }).then(function(response){
                    if(response.data)
                    {
                        this.company_assigned = true;
                        this.public_info = response.data;
                        this.employee_id = this.public_info.employee_id;
                        this.dCompanyId = this.public_info.company_id;

                        if(this.public_info.pic != '')
                            this.avatarsrc = this.$api_url+'/avatar/'+ this.public_info.company_id + '/' + this.public_info.pic;
                        else
                            this.avatarsrc = this.$api_url+'/avatar/demo.jpg';
                    }
                    else
                    {
                        this.company_assigned = false;
                        this.no_company_message = 'As soon as you are associated with any company, you will be able to see all data accordingly!';
                    }
                    
                    
                    
                }.bind(this));
            },
            getCompanyData:function() 
            {   
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/front/company/details' , {
                    params: {
                       
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        this.fdata = response.data;
                        this.company_id =  response.data.id;
                        this.logosrc = this.$api_url+'/images/company/' + response.data.logo;
                        this.companyname =  response.data.name;
                        this.addons =  response.data.module_disabled;
                        this.loan_settings =  response.data.loan_settings;

                        if(response.data.no_of_employees == 0)
                            this.employee_err = true;
                        
                        if((response.data.tin == '') || (response.data.tax_zone == '') || (response.data.tax_circle == '')) 
                            this.overview_err = true;
                    
                        this.checkIsManager();
                    }             
                    
                }.bind(this));


            },

            /*checkIsManager: function()
            {
                if(!this.checkNet()) return false;
                
                axios.get(this.$api_url+'/front/ismanager' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //alert(response.data);
                    if(response.data == 1)
                        this.is_manager = true;

                }.bind(this)).catch(function (error){this.serverError(error);});

            },*/
            checkIsApprover: function()
            {
                if(!this.checkNet()) return false;
                
                axios.get(this.$api_url+'/front/approver/check').then(function(response){
                    this.is_approver = response.data[0] || response.data[1]

                }.bind(this)).catch(function (error){this.serverError(error);});

            },
            // Rejwan: pf_unified
            checkIsAdvanceSettlementApprover: function()
            {
                if(!this.checkNet()) return false;
                // axios.get(this.pageurl+'/isapprover' , { // Start: Rejwan: 19-02-2026 Front Routes
                axios.get(this.$api_url+'/front/isapprover' , { // Start: Rejwan: 19-02-2026 Front Routes
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                        this.is_advance_settlement_manager = response.data;

                }.bind(this)).catch(function (error){this.serverError(error);});
            },
            // Rejwan: pf_unified
            checkIsRosterApprover: function()
            {
                if(!this.checkNet()) return false;
                
                axios.get(this.$api_url+'/front/leave-attendance/approver/check').then(function(response){
                    this.is_roster_approver = response.data[0] || response.data[1]

                }.bind(this)).catch(function (error){this.serverError(error);});

            },
            checkIsManager: function()
            {
                if(!this.checkNet()) return false;
                
                axios.get(this.$api_url+'/front/ismanager' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    if(response.data.reload == 1)
                    {
                        window.location.reload();
                    }
                    if(response.data.is_manager == 1)
                    {
                        this.is_manager = true;

                        /*if(response.data.is_line_manager == 1)
                        {
                            this.is_line_manager = 1;
                        }*/

                        if(response.data.is_manager == 1)
                        {
                            this.is_manager = true;

                            if(response.data.is_line_manager == 1)
                            {
                                this.is_line_manager = 1;
                                if(this.is_line_manager == 1) {
                                    if(this.addons.includes('Roster')){
                                        this.swapComponent('roster-approver-index');
                                    } else if(this.addons.includes('LeaveAttendances')){
                                        this.swapComponent('leaveattendances-dashboard-front');
                                    }
                                }
                            }
                        }
                    }                        

                }.bind(this)).catch(function (error){this.serverError(error);});
            },
            flusSubordinate: function()
            {
                
                let formData = new FormData();                
                formData.append('sess', 'subordinate_id');
                axios.post(this.$api_url+'/front/flushsess', formData)
                                .then(function (response) {
                   
                }.bind(this));
            },

            toggleSubmenu: function(event)
            {
                //this.submenu_active = !this.submenu_active;
                if (event) {
                    event.target.classList.toggle('active')
                }
            },
            
        },        
        
        created: function(){
            this.get_access_settings();
            this.getEmployeePublicData();
            this.getCompanyData();
            this.checkIsApprover();
            this.checkIsAdvanceSettlementApprover(); // Rejwan: pf_unified
            this.checkIsRosterApprover();
            //this.checkIsManager();
            this.flusSubordinate();
            this.checkServiceBookEligibility();

            if(this.$cookies.isKey("last_clicked_component"))
            {
                
                if(this.$cookies.get("last_clicked_component") != null)
                {
                    let component_name = this.$cookies.get("last_clicked_component");
                    this.currentComponent = component_name;
                    this.activeItem = component_name;
                }
                    
            }
        },
        watch: {
            sidebarOpen(newVal) {
                if (newVal) {
                    document.body.classList.add('mobile-sidebar-open');
                } else {
                    document.body.classList.remove('mobile-sidebar-open');
                }
            }
        }

    }

</script> 

<style>
.fa.fa-lock.trz_lock_front_sidebar {
	float: right;
}
.notification {
	float: right;
	/* padding: 5px 6px; */
	background: #f76060;
	color: #fff !important;
	border-radius: 14px;
	width: 23px;
	text-align: center;
	font-size: 13px !important;
	height: 24px;
	line-height: 24px;
	margin-right: 5px;
}
</style>
